import Parameter from "~/common/components/Parameter";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { selectCstic } from "../redux/selectCstic";
import { SimpleCsticId } from "../models";
import { CarriageAmount, GuidewayAmount } from "../v2/configuration/kuem/KUEMUnitCstics";

export const KUEMUnitSummaryParams = () => {
  const { t } = useTranslation();
  const railAmount = +(useSelector(selectCstic(SimpleCsticId(GuidewayAmount)))?.value ?? 0);
  const carriageAmount = +(useSelector(selectCstic(SimpleCsticId(CarriageAmount)))?.value ?? 0);

  return (
    <>
      <Parameter
        label={t("cartPage.systemLayout.label")}
        value={
          <>
            <div>
              {t("linearConfigSummary.guideway.info", {
                count: railAmount,
              }) + ","}
            </div>
            <div>
              {t("linearConfigSummary.carriages.info", {
                count: carriageAmount,
              })}
            </div>
          </>
        }
      />
    </>
  );
};
